import { render, staticRenderFns } from "./PaymentSettingBlock.vue?vue&type=template&id=cd2cd20e&scoped=true&"
import script from "./PaymentSettingBlock.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2cd20e",
  null
  
)

export default component.exports